import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import CrossIcon from '@/shared/assets/cross.svg?svg';
import TelegramIcon from '@/shared/assets/telegram.svg?svg';
import { Box, Text } from '@/shared/ui';
import { Qr } from './Qr';
import styles from './TelegramModal.module.css';

const LINK = 'https://t.me/crime_r';

export const TelegramModal = () => {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Modal
        classNames={{ content: styles.modal, body: styles.body }}
        styles={{
          header: {
            display: 'none',
          },
        }}
        opened={opened}
        onClose={close}
      >
        <button className={styles.closeButton} onClick={close}>
          <CrossIcon />
        </button>
        <Box display="flex" flexDirection="column" gap={18}>
          <Text fontSize={26} fontWeight={700} color="black">
            Канал &quot;Преступная Россия&quot;
          </Text>
          <Text fontSize={15} fontWeight={400} color="neutral-4-70">
            Присоединяйся к нам в Телеграмм
          </Text>
        </Box>

        <Qr link={LINK} />

        <a
          className={styles.modalButton}
          href={LINK}
          target="_blank"
          rel="noreferrer"
        >
          <Text fontSize={14} fontWeight={600} color="text-primary">
            Открыть Телеграм
          </Text>
        </a>
      </Modal>

      <button className={styles.button} onClick={open}>
        <TelegramIcon />
        <Text
          color="text-secondary"
          fontSize={12}
          fontWeight={700}
          lineHeight={20}
        >
          Телеграм канал
        </Text>
      </button>
    </>
  );
};
